/* ================================================== */
/* IOS VH
/* ================================================== */

function iosVh() {

	var vh100 = $(window).height() + 'px';
	// $(window).height() keeps a constant value, compared to window.innerHeight

	if (checkIos() === true) {

		$('body.default .main-content, .works #content').css('min-height', vh100);
		$('#projects > *').css('height', 'calc(' + vh100 + ' - 58px)');

	} else {

		$('body.default .main-content, .works #content').css('min-height', '100vh');
		$('#projects > *').css('height', 'calc(100vh - 58px)');

	}

}

$(window).on('resize orientationchange', function() {
	iosVh();
});